import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { IParameter } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';
import { useCreateOrUpdateParameterMutation, useDeleteParameterMutation, useGetParameterMutation } from '../../../api/ParameterAPI';

const emptyDto: IParameter = {
  uid: undefined,
  key: '',
  value: '',
}

export default function ParameterDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [getParameterAPI] = useGetParameterMutation();
  const [deleteParameterAPI] = useDeleteParameterMutation();
  const [createOrUpdateParameterAPI] = useCreateOrUpdateParameterMutation();
  
  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IParameter>(emptyDto);

  const init = () => {

    if (location.state.view === 'detail') {
      getParameterAPI(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten(e);
          setLoaded(true);
        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyDto)
      setLoaded(true);
    }
  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteParameterAPI(daten!.uid!).unwrap()
        .then(() => navigate('/admin/parameter/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail' || location.state.view === 'create') {

      if (location.state.view === 'detail') {

        createOrUpdateParameterAPI(daten)
          .then(resp => navigate('/admin/parameter/'))
          .catch((ee) => console.log(ee))
      }

      if (location.state.view === 'create') {

        createOrUpdateParameterAPI(daten)
          .then(resp => navigate('/admin/parameter/'))
          .catch((ee) => console.log(ee))
      }

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{t('deTranslation.adminParameterDetail.title')}</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >
            {(isLoaded && daten !== undefined &&
              <>
                <div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.uid}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" className={styles["wg-a"]} onClick={handleDelete}><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Key</label><input type="text" className={styles['wg-input-text']} name="key" value={daten?.key} onChange={changeit} /></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Value</label><input type="text" className={styles['wg-input-text']} name="value" value={daten?.value} onChange={changeit} /></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>
                  <div></div>
                </div>

              </>)}
          </form>


        </div>
      </div >
    </>
  );
}